import React from "react";
import { Link } from "react-router-dom";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

import publicCharterData from "./data/public-and-charter.json";
import privateSchoolsData from "./data/privateSchools.json";

// Calculate counts
const charterSchoolCount = publicCharterData.sections.sheet1.filter(
  (school) => school.school_type === "Charter"
).length;

const privateSchoolCount = privateSchoolsData.sections.sheet1.length;

const cards = [
  {
    imgsrc: "/img/educational/university.png",
    title: "Utah Universities",
    value: " Explore 36 Universities in Utah",
    link: "/utah-at-a-glance/universities-and-schools/utah-universities",
  },
  {
    imgsrc: "/img/educational/school.png",
    title: "Schools in Utah",
    value: "School District 41 (2023) Number of Schools : 956",
    link: "/utah-at-a-glance/universities-and-schools/utah-schools",
  },
  {
    imgsrc: "/img/educational/school.png",
    title: "Chartered Schools",
    value: `Explore ${charterSchoolCount} charter schools by county in Utah`,
    link: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
  },
  {
    imgsrc: "/img/educational/school.png",
    title: "Private Schools",
    value: `Explore ${privateSchoolCount} private schools by county in Utah`,
    link: "/utah-at-a-glance/universities-and-schools/utah-schools/private-schools",
  },
];

const EducationResources = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "eduandresource.webp",
          title: "Universities and Schools",
        }}
      />

      <div className="mt-[2rem] p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-items-center">
        {cards.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className="block w-full max-w-[440px] no-underline"
          >
            <div className="relative p-5 h-[320px] flex flex-col justify-between items-center text-center overflow-hidden rounded-2xl shadow-lg bg-orange-100 hover:shadow-2xl hover:scale-105 transform transition duration-300">
              {/* Icon */}
              <div className="w-24 h-24 flex items-center justify-center rounded-full bg-white shadow-md">
                <img
                  src={item.imgsrc}
                  alt={item.title}
                  className="w-16 h-16 object-contain rounded-full"
                />
              </div>

              <div className="flex flex-col items-center gap-2">
                {/* Title */}
                <h2 className="text-xl font-bold text-indigo-900 tracking-wide leading-snug">
                  {item.title}
                </h2>

                {/* Value */}
                <p className="text-base text-indigo-700 font-medium leading-snug line-clamp-3">
                  {item.value}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default EducationResources;
